<template>
  <div v-loading="loading">
    <span class="title-bar title-h4">에러 정보</span>
    <div class="list-info">
      <div>
        <span class="tit">클래스</span>
        <span class="high">{{ checkEmptyData(errorData.errorClassNameText) }}</span>
      </div>
      <div>
        <span class="tit">원인</span>
        <span class="high">{{ checkEmptyData(errorData.errorCauseText) }}</span>
      </div>
    </div>
    <span class="title-bar title-h4">스택 트레이스</span>
    <el-input readonly type="textarea" v-model="stacktrace" :autosize="{minRows: 14}" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { isEmpty as objectIsEmpty } from 'lodash';
import { isEmpty } from '@/utils/basic';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertThousandSeparatorFormat } from '@/utils/number';
import TransactionAPI from '@/api/apm/transaction';
import { TX_ID_STRING, OBJ_HASH } from '@/constants/apm-domain-define';

const EMPTY_TRACE = '데이터가 없습니다.';
export default {
  name: 'WErrorView',
  props: {
    activeTab: String,
    params: Object,
  },
  data() {
    return {
      errorData: {},
      loading: false,
      stacktrace: EMPTY_TRACE,
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    activeTab() {
      this.loadData();
    },
    params() {
      this.loadData();
    },
  },
  methods: {
    /**
     * 에러 데이터 호출
     * @return {[type]} [description]
     * @author jda
     */
    loadData() {
      if (this.activeTab !== 'error' || objectIsEmpty(this.params)) {
        return;
      }
      this.loading = true;
      const requestParam = {};
      requestParam[TX_ID_STRING] = this.params.txid;
      requestParam[OBJ_HASH] = this.selectedNode.objHash;
      TransactionAPI.getDetailError(requestParam).then((response) => {
        this.loading = false;
        if (response.data.success) {
          const result = response.data.data;

          this.stacktrace = isEmpty(result.errorStackTraceText) ? EMPTY_TRACE : result.errorStackTraceText;
          this.errorData = result;
        } else {
          this.errorData = {};
        }
      });
    },
    /**
     * empty text 체크
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     * @author jda
     */
    checkEmptyData(value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 에러 수 천단위 환산
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     * @author jda
     */
    convertNumberFormat(value) {
      if (isEmpty(value)) {
        return EMPTY_TEXT;
      }
      return convertThousandSeparatorFormat(value);
    },
    /**
     * 필드 초기화
     * @author jda
     */
    reset() {
      this.errorData = {};
    },
  },
};
</script>

<style lang="scss" scoped>

.list-info{
  flex-wrap: wrap;
  align-items: center;
  min-height: 55px;
  border: 1px solid #e9e9e9;
  background-color: #f4f4f5;
  margin-bottom: 10px;
  padding: 4px 18px;

  .high{
    color: #5372a5;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/apm/transaction-matrix/components/ErrorView.vue